export const getFullname = (obj, isPatronymic) => {
    if (obj.fullnameRu) return obj.fullnameRu;
    return `${obj.lastnameRu || ''} ${obj.nameRu || ''} ${isPatronymic && obj.patronymicRu ? obj.patronymicRu : ''}`
        .trim();
}